#import "../../../../core-entity/graphql/fragments/tag-fragment.graphql"

fragment TagCount on Tag {
    ...TagFragment
    count
}
